/**
 * Appearance preference: system | light | dark, persisted per client.
 * The pure resolution logic lives here so web and mobile can never
 * drift (ticket #122 ported web onto it; mobile's ui/appearance.ts is
 * a re-export shim). The IO lives platform-side: AsyncStorage in
 * mobile's ui/theme.tsx, localStorage in web's theme.ts.
 */

export type AppearancePref = "system" | "light" | "dark";
export type Scheme = "light" | "dark";

export const APPEARANCE_KEY = "tt.appearance.v1";

/**
 * The user's preference wins over the OS; "system" follows the OS. An
 * unknown stored value falls back to system rather than crashing.
 */
export function resolveScheme(
  pref: AppearancePref,
  system: Scheme | null | undefined,
): Scheme {
  if (pref === "light" || pref === "dark") return pref;
  return system === "dark" ? "dark" : "light";
}

export function isAppearancePref(value: unknown): value is AppearancePref {
  return (
    value === "system" || value === "light" || value === "dark"
  );
}
